import { styled } from '@mui/system';
export const SectionHeading = styled('h2') `
  font-weight: 600;
  font-size: 16px;
  color: ${({ theme }) => theme.palette.grey[900]};
  margin: 0px;
  grid-column: 1 / -1;
`;
export default SectionHeading;
